let subject = {
  showItems: false,
  searchFilters: {
    search_query: null,
    classifiers: []
  }
};

const getters = {
  GET_CLASSIFIERS( state ) {
    return state.searchFilters.classifiers
  },
  GET_SEARCH_QUERY( state ) {
    return state.searchFilters.search_query
  },
  GET_SHOW_ITEMS(state) {
    return state.showItems;
  },
};
const mutations = {
  RESET_SEARCH(state) {
    state.searchFilters.search_query = "";
    state.searchFilters.classifiers = [];
  },
  SET_SEARCH_FILTERS(state, data) {
    if (data.hasOwnProperty('search_query')) state.searchFilters.search_query = data.search_query;
    if (data.hasOwnProperty('classifiers')) state.searchFilters.classifiers = data.classifiers;
  },
  SET_SHOW_ITEMS(state, data) {
    state.showItems = data;
  },
  ADD_CLASSIFIERS(state, data) {
    state.searchFilters.classifiers = data
  },
  ADD_SEARCH_QUERY ( state , data ) {
    state.searchFilters.search_query = data
  }
};

const actions = {
  setSearchFilters({ commit }, data) {
    commit("SET_SEARCH_FILTERS", data);
  },
  setShowItems({ commit }, data) {
    commit("SET_SHOW_ITEMS", data);
  },
  hideItems({ commit }) {
    commit("HIDE_ITEMS");
  },
  resetSearch({ commit }) {
    commit("RESET_SEARCH");
  },
  addClassifiers({ commit }, data) {
    commit("ADD_CLASSIFIERS", data)
  },
  addSearchQuery ({ commit }, data) {
    commit("ADD_SEARCH_QUERY", data)
  },
};

export default {
  namespaced: true,
  state: subject,
  getters,
  mutations,
  actions
};
